<DateRangePicker class="pull-right" [options]="{quickSelect:dateRanges,dateRange:defaultRange,minDate:inceptionDate!}" (dateChange)="onDatesChange($event)" />
<div class="custom-control custom-checkbox my-2 pull-left">
  <input type="checkbox" class="custom-control-input" [(ngModel)]="DepositsWithdrawalsOnly" id="DepositsWithdrawalsOnly{{id}}" (change)="DWChange()">
  <label class="custom-control-label" for="DepositsWithdrawalsOnly{{id}}" style="line-height: 1.5em;">Show deposits and withdrawals only</label>
</div>

@if (tableOptions.request.FilterValue.length>0) {
  <NWMTable [options]="tableOptions" #NWMTable class="table-hover" />
}
